import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TypePageProfile } from '@app/profile/profile';
import { ProfileService } from '@app/profile/profile.service';
import { BaseApi } from '@services/base-api';
import { OtherService } from '@services/other.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MeProfileOfficialService extends BaseApi {
  readonly typePageProfile: TypePageProfile = 'meProfileOfficial';

  constructor(
    private profileS: ProfileService,
    public http: HttpClient,
    public otherS: OtherService,
  ) {
    super(http, otherS);
  }

  getCalendarSyncUrl(): Observable<{ calendarUrl: string | undefined } | undefined> {
    return this.put(`/api/core/v1/calendar`);
  }
}
